import { render, staticRenderFns } from "./Format1.vue?vue&type=template&id=48b253b0&scoped=true"
import script from "./Format1.vue?vue&type=script&lang=js"
export * from "./Format1.vue?vue&type=script&lang=js"
import style0 from "./Format1.vue?vue&type=style&index=0&id=48b253b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b253b0",
  null
  
)

export default component.exports